export enum PostCheckoutFlow {
  PreCapture = 'PRE_CAPTURE',
  PostCapture = 'POST_CAPTURE',
  Ineligible = 'INELIGIBLE',
}

export const whitelistedCaptureType = [PostCheckoutFlow.PreCapture, PostCheckoutFlow.PostCapture]

export interface Asset {
  id: AssetId
  label: string
  maxImpressions: number
  redirectionDelay?: number
}

export enum AssetId {
  Dummy = 'ap-asset-999999',
  Survey202303 = 'ap-asset-202303',
  GiftCard202306 = 'ap-gift-card-202306',
  GoogleSSO = 'google-sso-202308',
  MarketingOptIn202308 = 'ap-marketing-opt-in-202308',
  CashAppOrderServicingMessage202503 = 'unicorn-order-servicing-message-20250327',
}

const DUMMY = {
  label: 'Dummy Asset',
  maxImpressions: 3,
} as const

const SURVEY202303 = {
  label: 'Afterpay Survey',
  maxImpressions: 3,
} as const

const GIFTCARD202306 = {
  label: 'Afterpay Gift Card',
  maxImpressions: 3,
} as const

const GOOGLESSO = {
  label: 'Google SSO',
  maxImpressions: 1,
}

const MARKETINGOPTIN202308 = {
  label: 'Afterpay Marketing Opt In',
  maxImpressions: 3,
}

const CASHAPPORDERSERVICINGMESSAGE202503 = {
  label: 'Unicorn Cohort Order Servicing Message',
  maxImpressions: 5,
  redirectionDelay: 6000,
}

export const assetVault: Record<AssetId, Asset> = {
  [AssetId.Dummy]: { ...DUMMY, id: AssetId.Dummy },
  [AssetId.Survey202303]: { ...SURVEY202303, id: AssetId.Survey202303 },
  [AssetId.GiftCard202306]: { ...GIFTCARD202306, id: AssetId.GiftCard202306 },
  [AssetId.GoogleSSO]: { ...GOOGLESSO, id: AssetId.GoogleSSO },
  [AssetId.MarketingOptIn202308]: { ...MARKETINGOPTIN202308, id: AssetId.MarketingOptIn202308 },
  [AssetId.CashAppOrderServicingMessage202503]: {
    ...CASHAPPORDERSERVICINGMESSAGE202503,
    id: AssetId.CashAppOrderServicingMessage202503,
  },
}

export type PostCheckoutSupportedSteps = 1 | 2

export const postCheckoutFlowSteps: Record<PostCheckoutFlow, PostCheckoutSupportedSteps> = {
  [PostCheckoutFlow.PreCapture]: 1,
  [PostCheckoutFlow.PostCapture]: 2,
  [PostCheckoutFlow.Ineligible]: 1,
}

export enum PreferredMarketingNotification {
  EMAIL = 'email',
  PUSH = 'push',
}

export const DEFAULT_ASSET_VERSION = 1

export interface PostCheckoutEligibility {
  result: boolean
  browser: boolean
  consumer: boolean
  order: boolean
  asset: boolean
  merchant: boolean
}
